// 传列表
export const getKvlistGql = `query{$tableName (_limit:$limit,_offset:$offset,_order_by:{create_time:_desc}$filter){_aggregate{_count},key,value,remark,type,id,create_by,create_time,update_by,update_time,value_type,value_ext,is_locked,is_env_specific,version}}`;

// 删除
export const deleteKvGql = 'mutation delete {$tableName (id: $id)}';

// 新增
export const addKvGql = `mutation insert {$tableName(_values:{fieldList})}`;

// 更新
export const updateKvGql = `mutation update {$tableName (_where: {id: $id, version: $version}, _set: {fieldList,version:_expr(version,_op("+"),1)})}`;

// 用key更新
export const updateKvByKeyGql = `mutation insert {$tableName( _values:[$updateList], _on_conflict: {_columns: [key], _update_all:true})}`;
